import { render, staticRenderFns } from "./localmenus.vue?vue&type=template&id=122dd502"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('122dd502')) {
      api.createRecord('122dd502', component.options)
    } else {
      api.reload('122dd502', component.options)
    }
    module.hot.accept("./localmenus.vue?vue&type=template&id=122dd502", function () {
      api.rerender('122dd502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/editor/helpers/localmenus.vue"
export default component.exports